import React from 'react'
import thunkMidleware from 'redux-thunk'
import { combineReducers, createStore, applyMiddleware } from 'redux'
import { useDispatch, useSelector } from 'react-redux'
import { selectAuth } from '@selectors'

import { ConferenceRoom, VoxeetProvider, reducer as voxeetReducer } from '@voxeet/react-components'

import { useParams } from 'react-router-dom'
import { SET_REDIRECT } from '@redux/actions/types'

const reducers = combineReducers({
  voxeet: voxeetReducer
})

const configureStore = () =>
  createStore(reducers, applyMiddleware(thunkMidleware))

const PriorityConnect = () => {
  const dispatch = useDispatch()

  const { conferenceAlias, personalAccessCode } = useParams()

  const auth = useSelector(selectAuth)

  const getUserName = () => {
    if (auth.firstName && auth.lastName) {
      return `${auth.firstName} ${auth.lastName}`
    } else if (auth.username) {
      return auth.username
    }
    return `Subscriber: ${auth.subscriberId}`
  }

  const userInfo = {
    name: getUserName(),
    externalId: auth.subscriberId
  }

  const handleOnLeave = () => {
    dispatch({
      type: SET_REDIRECT,
      payload: `/${personalAccessCode}/messages`
    })
  }

  return (
    <VoxeetProvider store={configureStore()}>
      <ConferenceRoom
        autoJoin
        conferenceAlias={conferenceAlias}
        constraints={{
          audio: true,
          video: true
        }}
        consumerKey='cGRzZd5FVzlcXGDGvTDkPw=='
        consumerSecret='VkE7t7O6AMViu8LlzDiskOtsmd0JJjJTybX0PNxq0-k='
        displayActions={['mute', 'video', 'share', 'live', 'chat', 'attendees']}
        handleOnLeave={handleOnLeave}
        isWidget={false}
        userInfo={userInfo}
      />
    </VoxeetProvider>
  )
}

export default PriorityConnect
